import styled, { css } from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { VisuallyHidden } from '../../../../ui-components/utils.styles';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import { regularWhite, fontWeightBold } from '../../../../ui-components/design-tokens';

export const Navigation = styled.nav`
    position: relative;
    margin-left: 10px;
    margin-right: 10px;

    @media ${device.GteLarge} {
        margin-left: 0;
        margin-right: 0;
    }
`;

export const LogoText = styled.span`
    ${VisuallyHidden}
`;

export const MenuItems = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
    ${playFontSize(1.6)}
    color: ${regularWhite};

    @media ${device.GteSmall} {
        float: left;
        margin: 0 0 4px;
        ${playFontSize(1.7)}
    }
`;

export const SearchToggle = styled.label`
    display: block;
    padding: 10px 8px;
    color: ${regularWhite};
    text-decoration: none;
    cursor: pointer;
    ${playFontSize(1.4)}

    &:focus {
        outline: none;
    }

    &:hover,
    &:active,
    &:visited {
        color: ${regularWhite};

        .no-touchevents && {
            text-decoration: underline;
        }
    }

    &.play_is-active {
        font-weight: ${fontWeightBold};
    }

    @media ${device.GteSmall} {
        padding: 10px 15px 10px 10px;
    }

    @media ${device.GteMedium} {
        padding: 10px 15px;
    }
`;

export const SearchListItem = styled.li`
    margin: 8px 0 0;
    width: 100%;
    float: left;
    position: relative;
    bottom: 5px;
    right: 0;

    @media ${device.GteSmall} {
        margin: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 220px;
    }

    ${(props) =>
        props.hiddenXs &&
        css`
            display: none;

            .no-js & {
                display: block;
            }

            @media ${device.GteSmall} {
                display: block;
            }
        `}
`;

SearchListItem.displayName = 'SearchListItem';
